<!-- <body> -->
    <div class="content">
        <div class="container-fluid">
            <p class="ticket_title">Tickets Details</p>
            <div class="ticket_box">
                <!-- BOX CREATED -->
                <div class="row">
                    <div class="col-md-9">
                        <div class="complaint_box">
                            <div class="complaint_name">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="svg_icon"
                                    (click)="mainScreen()" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                                        fill="#555555" />
                                </svg>
                                <p class="complaint_fee">Complaint Regarding {{parentDetails.grievanceName}} <span
                                        class="name">by
                                        {{parentDetails?.parentName}}
                                        ({{admNO}})</span></p>
                                <p class="date">{{ date | date:'dd/MM/yyyy' }}</p>
                            </div>

                            <div class="tab_list">
                                <button class="Assign" (click)="onAccept()" [disabled]="disableAccept"
                                    [ngClass]="{'backgroundColor': currentActive === 'Accept'}"
                                    [ngStyle]="{ opacity: disableAccept  ? 0.2 : 1 }">
                                    Accept
                                </button>
                                <button class="Assign" (click)="onAssign()" [disabled]="disableAssign "
                                    [ngClass]="{'backgroundColor': currentActive === 'Assign'}"
                                    [ngStyle]="{ opacity: disableAssign ? 0.2 : 1 }">
                                    Assign
                                </button>
                                <button class="Assign" (click)="onEscalated()" [disabled]="disableEscalate"
                                    [ngClass]="{'backgroundColor': currentActive === 'Escalate'}"
                                    [ngStyle]="{ opacity: disableEscalate ? 0.2 : 1 }">
                                    Escalate
                                </button>
                                <button class="Assign" (click)="onNote()" [disabled]="disableNote "
                                    [ngClass]="{'backgroundColor': currentActive === 'Note'}"
                                    [ngStyle]="{ opacity: disableNote  ? 0.2 : 1 }">
                                    Note
                                </button>
                            </div>
                        </div>

                        <div class="complaint_box1">
                            <p class="regard" style="color: #026fd4; margin-bottom: 10px; font-size: 16px;">Grievance
                                Description</p>
                            <div class="comp_regard">
                                <div>
                                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" class="show_cursor"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="51" height="51" rx="7.5" fill="#F7FCFE" />
                                        <rect x="0.5" y="0.5" width="51" height="51" rx="7.5" stroke="#CAD2DE" />
                                        <path
                                            d="M18.5 16.833C18.5 20.968 21.865 24.333 26 24.333C30.135 24.333 33.5 20.968 33.5 16.833C33.5 12.698 30.135 9.33301 26 9.33301C21.865 9.33301 18.5 12.698 18.5 16.833ZM39.3333 40.9997H41V39.333C41 32.9013 35.765 27.6663 29.3333 27.6663H22.6667C16.2333 27.6663 11 32.9013 11 39.333V40.9997H39.3333Z"
                                            fill="#B5C3CA" />
                                    </svg>
                                </div>
                                <div
                                    style="width: 93%;word-wrap: normal;white-space: break-word;word-break: break-word;">

                                    <div class="display_regard">
                                        <p class="regard">{{parentDetails?.grievanceName}}</p>
                                    </div>
                                    <p class="regard_text">
                                        {{parentDetails?.details}}
                                    </p>
                                    <!-- <div class="right_new"> -->
                                    <!-- <ng-container *ngIf="data.trackStatus ==='OPEN'">
                                                    <span class="new_open">{{data.trackStatus}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="data.trackStatus ==='IN PROGRESS'">
                                                    <span class="new_inprogress">{{data.trackStatus}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="data.trackStatus ==='RESOLVED'">
                                                    <span class="new_resolved">{{data.trackStatus}}</span>
                                                </ng-container>
                                            </div> -->
                                </div>
                            </div>
                        </div>

                        <!-- CLICK ACCEPT TO SHOW  -->

                        <ng-container *ngIf="showAccepted">
                            <div class="update_list">
                                <textarea name="" id="" class="text_area form-control" rows="1" maxlength="2000"
                                    [(ngModel)]="accpetTextremarks" placeholder="Enter your remarks"></textarea>

                                <!-- <div class="editor">
                                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                                    </ngx-editor-menu>
                                    <ngx-editor [editor]="editor"  [(ngModel)]="accpetTextremarks" maxlength="2000">
                                    </ngx-editor>
                                </div> -->

                                <div class="char-limit">Max :{{ maxChars - accpetTextremarks.length }}/2000</div>
                            </div>
                            <div class="update_list">
                                <div class="upload" (click)="fileInput.click()" (dragover)="onDragOver($event)"
                                    (drop)="onDrop($event)">
                                    <input type="file" #fileInput hidden (change)="onFileSelected($event)">
                                    <div class="cloud_item">
                                        <img src="../../../../assets/image/grievance/mdi-light_cloud-upload.svg" alt="">
                                        <p class="Browse">Browse Files</p>
                                        <p class="Drag">Drag and drop files here</p>
                                        <p class="file_Drag">File size should be less than 1 MB</p>
                                    </div>
                                </div>
                                <!-- Show file name if valid -->
                                <div *ngIf="selectedFile">
                                    <p class="file-info">Selected: {{ selectedFile.name }} ({{ selectedFile.size /
                                        1024 / 1024 |
                                        number:'1.2-2' }} MB)</p>
                                </div>

                                <!-- Show error -->
                                <div *ngIf="fileError" class="error">
                                    <p style="color: red; margin-bottom: 0px;">{{ fileError }}</p>
                                </div>
                            </div>
                            <div class="update_list">
                                <div class="sub_display">
                                    <button class="Submit_close" (click)="onSubmit()">Submit & Close Ticket</button>
                                    <button class="cancel" (click)="cancel()">Cancel</button>
                                </div>
                            </div>
                        </ng-container>

                        <!-- CLICK ASSIGN DESIGN-->

                        <ng-container *ngIf="onAssignShowMain">
                            <div class="display_building">
                                <p class="type_bild">Assign To</p>
                                <div class="search_list">
                                    <input type="text" class="form-control" [(ngModel)]="searchCriteria"
                                        (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)"
                                        placeholder="Search by Payrollid/Name/Designation/Mobile">
                                    <i class="fa fa-search search_icon"></i>
                                </div>
                                <ul *ngIf="filteredSearchDetails?.length > 0" class="dropdown-list">
                                    <li *ngFor="let item of filteredSearchDetails" (click)="selectItem(item)">
                                        {{ item.empName }} ({{ item.payrollId }})
                                    </li>
                                </ul>
                            </div>
                            <!-- TEXT ASSIGN-->
                            <div class="update_list">
                                <textarea name="" id="" class="text_area form-control" rows="6" maxlength="2000"
                                    [(ngModel)]="assignTextremarks" placeholder="Enter"></textarea>
                                <div class="char-limit">Max{{ maxChars - assignTextremarks.length }} /2000</div>
                            </div>
                            <!-- ASSIGN BUTTON  -->
                            <div class="update_list">
                                <div class="sub_display">
                                    <button class="Submit_close" (click)="onAssignedTicket()">Assigned
                                        Ticket</button>
                                    <button class="cancel" (click)="assigncancel()">Cancel</button>
                                </div>
                            </div>
                        </ng-container>


                        <!--END CLICK ASSIGN DESIGN-->

                        <!-- CLICK Escalate DESIGN-->
                        <ng-container *ngIf="onEscalate">

                            <!-- TEXT ASSIGN-->
                            <div class="update_list">
                                <textarea name="" id="" class="text_area form-control" rows="6" maxlength="2000"
                                    [(ngModel)]="escalatedTextremarks" placeholder="Enter your remarks"></textarea>
                                <div class="char-limit">Max{{ maxChars - escalatedTextremarks.length }} /2000</div>
                            </div>
                            <!-- ASSIGN BUTTON  -->
                            <div class="update_list">
                                <div class="sub_display">
                                    <button class="Submit_close" (click)="onEscalateTicket()">Submit
                                        Escalate</button>
                                    <button class="cancel" (click)="escalatecancel()">Cancel</button>
                                </div>
                            </div>



                        </ng-container>

                        <!--END CLICK Escalate DESIGN-->

                        <!-- CLICK NOTE DESIGN-->
                        <ng-container *ngIf="onNoted">
                            <!-- TEXT ASSIGN-->
                            <div class="update_list">
                                <textarea name="" id="" class="text_area form-control" rows="6" maxlength="2000"
                                    [(ngModel)]="noteTextremarks" placeholder="Enter your remarks"></textarea>
                                <div class="char-limit">Max{{ maxChars - noteTextremarks.length }} /1000</div>
                            </div>
                            <!-- ASSIGN BUTTON  -->
                            <div class="update_list">
                                <div class="sub_display">
                                    <button class="Submit_close" (click)="onsubmitNote()">Submit Note</button>
                                    <button class="cancel" (click)="notecancel()">Cancel</button>
                                </div>
                            </div>
                        </ng-container>


                        <!--END CLICK NOTE DESIGN-->
                        <!-- DEFAULT TO SHOW -->
                        <ng-container>
                            <ng-container *ngFor="let data of grievanceStatusDetails?.noteHistory">
                                <div class="complaint_box1">
                                    <div class="d-flex">
                                        <p class="regard" style="color: #026fd4; margin-bottom: 10px; font-size: 16px;">
                                            Note -</p>
                                        <p style="margin-left: 10px;">{{data.employeeName}} /</p>
                                        <p style="margin-left: 10px;">{{data.designation}}</p>
                                    </div>
                                    <div class="comp_regard">
                                        <div>
                                            <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                                                class="show_cursor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="51" height="51" rx="7.5" fill="#F7FCFE" />
                                                <rect x="0.5" y="0.5" width="51" height="51" rx="7.5"
                                                    stroke="#CAD2DE" />
                                                <path
                                                    d="M18.5 16.833C18.5 20.968 21.865 24.333 26 24.333C30.135 24.333 33.5 20.968 33.5 16.833C33.5 12.698 30.135 9.33301 26 9.33301C21.865 9.33301 18.5 12.698 18.5 16.833ZM39.3333 40.9997H41V39.333C41 32.9013 35.765 27.6663 29.3333 27.6663H22.6667C16.2333 27.6663 11 32.9013 11 39.333V40.9997H39.3333Z"
                                                    fill="#B5C3CA" />
                                            </svg>
                                        </div>
                                        <div>
                                            <div class="display_regard">
                                                <p class="regard">{{parentDetails?.grievanceName}}</p>
                                            </div>
                                            <p class="regard_text">
                                                {{data.trackDesc}}
                                            </p>
                                            <!-- <div class="right_new"> -->
                                            <!-- <ng-container *ngIf="data.trackStatus ==='OPEN'">
                                                    <span class="new_open">{{data.trackStatus}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="data.trackStatus ==='IN PROGRESS'">
                                                    <span class="new_inprogress">{{data.trackStatus}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="data.trackStatus ==='RESOLVED'">
                                                    <span class="new_resolved">{{data.trackStatus}}</span>
                                                </ng-container>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <!--ENd DEFAULT TO SHOW -->

                        <!-- RESOLVED TRAC DESCRIPTION -->
                        <ng-container>

                            <ng-container *ngIf="grievanceStatusDetails?.latestDetails?.trackStatus ==='RESOLVED'">
                                <div class="complaint_box1">
                                    <p class="regard" style="color: #026fd4; margin-bottom: 10px; font-size: 16px;">
                                        Resolved Description</p>
                                    <div class="comp_regard">
                                        <div>
                                            <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                                                class="show_cursor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="51" height="51" rx="7.5" fill="#F7FCFE" />
                                                <rect x="0.5" y="0.5" width="51" height="51" rx="7.5"
                                                    stroke="#CAD2DE" />
                                                <path
                                                    d="M18.5 16.833C18.5 20.968 21.865 24.333 26 24.333C30.135 24.333 33.5 20.968 33.5 16.833C33.5 12.698 30.135 9.33301 26 9.33301C21.865 9.33301 18.5 12.698 18.5 16.833ZM39.3333 40.9997H41V39.333C41 32.9013 35.765 27.6663 29.3333 27.6663H22.6667C16.2333 27.6663 11 32.9013 11 39.333V40.9997H39.3333Z"
                                                    fill="#B5C3CA" />
                                            </svg>
                                        </div>
                                        <div>
                                            <div class="display_regard">
                                                <P class="regard">{{grievanceStatusDetails?.latestDetails?.trackDate}}
                                                </P>
                                            </div>
                                            <p class="regard_text">
                                                {{grievanceStatusDetails?.latestDetails?.trackDesc}}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <!--END RESOLVED TRAC DESCRIPTION -->

                    </div>


                    <div class="col-md-3">
                        <!-- ACCEPT TO TICKET LOGS -->


                        <div class="complaint_G">
                            <p class="G-1">{{parentDetails?.grievanceTrackId}}</p>
                            <!-- <div *ngIf="onacceptticket" [chart]="chart" style="width: 24px; height: 24px;"></div> -->
                        </div>
                        <ng-container>
                            <div class="complaint_G2">
                                <p class="ticket_log_no">Ticket Details
                                </p>

                                <div class="ticket_open">
                                    <p class="ticket_open_name data_title">Ticket opened
                                        by - {{grievanceStatusDetails?.latestDetails.employeeName}}</p>
                                    <div class="ticket_time">
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.58342 0.5C10.683 0.5 12.6967 1.33407 14.1813 2.81874C15.666 4.3034 16.5001 6.31704 16.5001 8.41667C16.5001 10.5163 15.666 12.5299 14.1813 14.0146C12.6967 15.4993 10.683 16.3333 8.58342 16.3333C6.48378 16.3333 4.47015 15.4993 2.98549 14.0146C1.50082 12.5299 0.666748 10.5163 0.666748 8.41667C0.666748 6.31704 1.50082 4.3034 2.98549 2.81874C4.47015 1.33407 6.48378 0.5 8.58342 0.5ZM8.58342 1.33333C6.7048 1.33333 4.90312 2.07961 3.57474 3.40799C2.24636 4.73638 1.50008 6.53805 1.50008 8.41667C1.50008 10.2953 2.24636 12.097 3.57474 13.4253C4.90312 14.7537 6.7048 15.5 8.58342 15.5C9.51361 15.5 10.4347 15.3168 11.2941 14.9608C12.1535 14.6048 12.9343 14.0831 13.5921 13.4253C14.2498 12.7676 14.7716 11.9867 15.1276 11.1273C15.4835 10.268 15.6667 9.34686 15.6667 8.41667C15.6667 6.53805 14.9205 4.73638 13.5921 3.40799C12.2637 2.07961 10.462 1.33333 8.58342 1.33333ZM8.16675 3.83333H9.00008V8.35L12.9167 10.6083L12.5001 11.3333L8.16675 8.83333V3.83333Z"
                                                fill="#888888" />
                                        </svg>
                                        <p class="day_ago">
                                            {{numberofDays}} day ago
                                        </p>
                                    </div>
                                    <div class="ticket_border"></div>
                                </div>
                                <div class="document">
                                    <p class="ticket_status">Ticket status - <span class="status_open"
                                            [ngStyle]="{ color: getStatusColor() }">{{grievanceStatusDetails?.latestDetails.trackStatus}}</span>
                                    </p>

                                    <button class="downloaded" [disabled]="!downloadPdf"
                                        (click)="getStudentDownload( admNO, grievanceId)">
                                        Download PDF
                                    </button>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container>
                            <div class="complaint_G3">
                                <p class="ticket_log_no1 ">Student Details</p>
                                <div class="ticket_open">
                                    <!-- <p class="ticket_open_name ticket_name">Ticket opened
                                        by - <span class="data">{{parentDetails?.parentName}}</span></p> -->
                                    <!-- <div class="ticket_time">
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.58342 0.5C10.683 0.5 12.6967 1.33407 14.1813 2.81874C15.666 4.3034 16.5001 6.31704 16.5001 8.41667C16.5001 10.5163 15.666 12.5299 14.1813 14.0146C12.6967 15.4993 10.683 16.3333 8.58342 16.3333C6.48378 16.3333 4.47015 15.4993 2.98549 14.0146C1.50082 12.5299 0.666748 10.5163 0.666748 8.41667C0.666748 6.31704 1.50082 4.3034 2.98549 2.81874C4.47015 1.33407 6.48378 0.5 8.58342 0.5ZM8.58342 1.33333C6.7048 1.33333 4.90312 2.07961 3.57474 3.40799C2.24636 4.73638 1.50008 6.53805 1.50008 8.41667C1.50008 10.2953 2.24636 12.097 3.57474 13.4253C4.90312 14.7537 6.7048 15.5 8.58342 15.5C9.51361 15.5 10.4347 15.3168 11.2941 14.9608C12.1535 14.6048 12.9343 14.0831 13.5921 13.4253C14.2498 12.7676 14.7716 11.9867 15.1276 11.1273C15.4835 10.268 15.6667 9.34686 15.6667 8.41667C15.6667 6.53805 14.9205 4.73638 13.5921 3.40799C12.2637 2.07961 10.462 1.33333 8.58342 1.33333ZM8.16675 3.83333H9.00008V8.35L12.9167 10.6083L12.5001 11.3333L8.16675 8.83333V3.83333Z"
                                                fill="#888888" />
                                        </svg>
                                        <p class="day_ago">
                                            {{numberofDays}} day ago
                                        </p>
                                    </div> -->

                                    <div class="display_row" style="width: 100%;">
                                        <div class="display_col">
                                            <div class="side_data_con">
                                                <p class="ticket_name">City Name </p>
                                                <p class="data">{{parentDetails?.cityName}}</p>
                                            </div>
                                            <div class="side_data_con">
                                                <p class="ticket_name">Campus Name </p>
                                                <p class="data">{{parentDetails?.CampusName}}</p>
                                            </div>
                                            <div class="side_data_con">
                                                <p class="ticket_name">Student Name </p>
                                                <p class="data">{{parentDetails?.studentName}}</p>
                                            </div>

                                            <div class="side_data_con">
                                                <p class="ticket_name">Group Name </p>
                                                <p class="data">{{parentDetails?.groupName}}</p>
                                            </div>
                                            <div class="side_data_con">
                                                <p class="ticket_name">Course Name </p>
                                                <p class="data">{{parentDetails?.coursetrackName}}</p>
                                            </div>
                                            <div class="side_data_con">
                                                <p class="ticket_name">Section Name </p>
                                                <p class="data">{{parentDetails?.sectionName}}</p>
                                            </div>
                                            <div class="side_data_con">
                                                <p class="ticket_name">Program Name </p>
                                                <p class="data">{{parentDetails?.programName}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="document">
                                    <!-- <p class="ticket_status">Ticket status - <span class="status_open"
                                            [ngStyle]="{ color: getStatusColor() }">{{grievanceStatusDetails?.[0].trackStatus}}</span>
                                    </p> -->

                                </div>
                            </div>
                        </ng-container>
                        <!-- </ng-container> -->

                        <!--END ACCEPT TO TICKET LOGS -->

                    </div>
                </div>

            </div>
        </div>
    </div>
<!-- </body> -->




<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>